import { Input } from '../../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Textarea } from '../../ui/textarea';
import { DeadlinePicker } from './DeadlinePicker';

const Field = ({ label, children }) => (
    <div className="space-y-2">
        <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted-foreground">{label}</p>
        {children}
    </div>
);

export const AssignDetailsPanel = ({ form, setForm, cycles }) => {
    const set = (key) => (value) => setForm((f) => ({ ...f, [key]: value }));
    return (
        <div className="space-y-6">
            <Field label="Deadline">
                <DeadlinePicker value={form.deadline} onChange={set('deadline')} />
            </Field>
            <Field label="Review cycle">
                <Select value={form.review_cycle} onValueChange={set('review_cycle')}>
                    <SelectTrigger data-testid="assign-review-cycle"><SelectValue /></SelectTrigger>
                    <SelectContent>
                        {cycles.map((c) => <SelectItem key={c.id} value={c.id} data-testid={`assign-review-cycle-${c.id}`}>{c.label}</SelectItem>)}
                    </SelectContent>
                </Select>
            </Field>
            <Field label="Call review notes · areas to improve">
                <Textarea
                    value={form.call_feedback}
                    onChange={(e) => set('call_feedback')(e.target.value)}
                    rows={5}
                    maxLength={4000}
                    placeholder="What you heard on their calls and what these simulations should fix, e.g. 'Jumps to salary before qualifying — practise discovery questions.'"
                    className="bg-background"
                    data-testid="assign-call-notes"
                />
            </Field>
            <Field label="Task title (optional)">
                <Input value={form.title} onChange={(e) => set('title')(e.target.value)} maxLength={120} placeholder="Auto-named from the review cycle if left blank" className="bg-background" data-testid="assign-task-title" />
            </Field>
        </div>
    );
};
